export default {
  isRequired(value) {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Это обязательное поле';
    }
    return true;
  },
  isRequiredAndEmail(value) {
    if (!value) return 'Это обязательное поле';
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!regex.test(String(value).toLowerCase())) {
      return 'Укажите правильный email'
    }
    return true;
  },
  isValidUrl(value) {
    const urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
      '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
    if (!urlPattern.test(String(value).toLowerCase())) {
      return 'Укажите полный адрес сайта в формате https://site.ru'
    }
    return true;
  }
}